/** TODO: Refactor Permissions */
export const BulkImports = [
  {
    name: "Offices",
    translationKey: "offices",
    entityType: "offices",
    urlSuffix: "/offices",
    permission: "READ_OFFICE",
    formFields: 0,
  },
  {
    name: "Users",
    translationKey: "users",
    entityType: "users",
    urlSuffix: "/users",
    permission: "READ_CLIENT",
    formFields: 2,
  },
  {
    name: "Groups",
    translationKey: "groups",
    entityType: "groups",
    urlSuffix: "/groups",
    permission: "READ_CLIENT",
    formFields: 2,
  },
  {
    name: "Centers",
    translationKey: "centers",
    entityType: "centers",
    urlSuffix: "/centers",
    permission: "READ_CENTERS",
    formFields: 2,
  },
  {
    name: "Clients",
    translationKey: "clients",
    entityType: "client",
    urlSuffix: "/clients",
    permission: "READ_CLIENT",
    formFields: 3,
  },
  {
    name: "Employees",
    translationKey: "employees",
    entityType: "staff",
    urlSuffix: "/staff",
    permission: "READ_CLIENT",
    formFields: 1,
  },
  {
    name: "Guarantors",
    translationKey: "guarantors",
    entityType: "guarantors",
    urlSuffix: "/loans/1/guarantors",
    permission: "READ_CLIENT",
    formFields: 1,
  },
  {
    name: "Journal Entries",
    translationKey: "journalEntries",
    entityType: "gljournalentries",
    urlSuffix: "/journalentries",
    permission: "READ_CLIENT",
    formFields: 1,
  },
  {
    name: "Loan Accounts",
    translationKey: "loanAccounts",
    entityType: "loans",
    urlSuffix: "/loans",
    permission: "READ_CLIENT",
    formFields: 2,
  },
  {
    name: "Savings Accounts",
    translationKey: "savingsAccounts",
    entityType: "savingsaccount",
    urlSuffix: "/savingsaccounts",
    permission: "READ_CLIENT",
    formFields: 2,
  },
  {
    name: "Fixed Deposit Accounts",
    translationKey: "fixedDepositAccounts",
    entityType: "fixeddepositaccounts",
    urlSuffix: "/fixeddepositaccounts",
    permission: "READ_CLIENT",
    formFields: 2,
  },
  {
    name: "Reccuring Deposit Accounts",
    translationKey: "recurringDepositAccounts",
    entityType: "recurringdeposits",
    urlSuffix: "/recurringdepositaccounts",
    permission: "READ_CLIENT",
    formFields: 2,
  },
  {
    name: "Chart of Accounts",
    translationKey: "chartOfAccounts",
    entityType: "chartofaccounts",
    urlSuffix: "/glaccounts",
    permission: "READ_CLIENT",
    formFields: 2,
  },
  {
    name: "Share Accounts",
    translationKey: "shareAccounts",
    entityType: "shareaccounts",
    urlSuffix: "/accounts/share",
    permission: "READ_CLIENT",
    formFields: 1,
  },
  {
    name: "Loan Repayments",
    translationKey: "loanRepayments",
    entityType: "loantransactions",
    urlSuffix: "/loans/repayments",
    permission: "READ_CLIENT",
    formFields: 1,
  },
  {
    name: "Savings Transactions",
    translationKey: "savingsTransactions",
    entityType: "savingstransactions",
    urlSuffix: "/savingsaccounts/transactions",
    permission: "READ_CLIENT",
    formFields: 1,
  },
  {
    name: "Fixed Deposit Transactions",
    translationKey: "fixedDepositTransactions",
    entityType: "fixeddeposittransactions",
    urlSuffix: "/fixeddepositaccounts/transaction",
    permission: "READ_CLIENT",
    formFields: 1,
  },
  {
    name: "Recurring Deposit Transactions",
    translationKey: "recurringDepositTransactions",
    entityType: "recurringdepositstransactions",
    urlSuffix: "/recurringdepositaccounts/transactions",
    permission: "READ_CLIENT",
    formFields: 1,
  },
];
